import SashiDo from 'lib/SashiDo';
import moment from 'moment';
import history from 'dashboard/history';

import AccountManager           from 'lib/AccountManager';
import Button                   from 'components/Button/Button.react';
import Icon                     from 'components/Icon/Icon.react';
import Field                    from 'components/Field/Field.react';
import Fieldset                 from 'components/Fieldset/Fieldset.react';
import FormButton               from 'components/FormButton/FormButton.react';
import FormModal                from 'components/FormModal/FormModal.react';
import FormTable                from 'components/FormTable/FormTable.react';
import KeyField                 from 'components/KeyField/KeyField.react';
import Label                    from 'components/Label/Label.react';
import Modal                    from 'components/Modal/Modal.react';
import React, { Component }     from 'react';
import PreLoader                from 'components/PreLoader/PreLoader.react';
import styles                   from 'dashboard/Settings/Settings.scss';
import billingStyles            from 'dashboard/Billing/Billing.scss';
import stylesButton             from 'components/Button/Button.scss';
import TextInput                from 'components/TextInput/TextInput.react';
import Toolbar                  from 'components/Toolbar/Toolbar.react';
import UploadAvatarOrIcon       from 'components/UploadAvatarOrIcon/UploadAvatarOrIcon.react';
import Notification             from 'components/Notification/Notification.react';

export default class AccountLegalCompliance extends Component {
  constructor(props) {
    super();

    const info = props.currentCustomer.info;

    this.state = {
      loading: false,
      showPrivacyPolicyModal: false,
      showTermsOfServiceModal: false,
      privacyNoticeModal: false,
      agreements: props.currentUser.agreements,
      acceptedBy: props.currentUser.email,

      euRepresentative: info.meta_data && info.meta_data.eu_representative ? info.meta_data.eu_representative : {},

      dpo: info.meta_data && info.meta_data.dpo ? info.meta_data.dpo : {},
    };

    this.showInfoBox =
      !props.currentUser.agreements.privacyPoliciesAcceptedDate ||
      !props.currentUser.agreements.termsOfServiceAcceptedDate ||
      !props.currentUser.agreements.privacyNoticeAcceptedDate
  }

  onClose() {
    this.setState({
      showPrivacyPolicyModal: false,
      showTermsOfServiceModal: false,
      privacyNoticeModal: false,
    });
  }

  agreePrivacyPolicy() {
    SashiDo.changeUserAgreement({ name: 'Privacy Policy', version: '1' }).then((result) => {
      this.setState({ agreements: { ...this.state.agreements, privacyPoliciesAcceptedDate: result.createdAt} });
      this.onClose();
    });
  }

  agreeTermsOfService() {
    SashiDo.changeUserAgreement({ name: 'Terms of Service', version: '1' }).then((result) => {
      this.setState({ agreements: { ...this.state.agreements, termsOfServiceAcceptedDate: result.createdAt} });
      this.onClose();
    });
  }

  agreePrivacyNotice() {
    SashiDo.changeUserAgreement({ name: 'Privacy Notice', version: '1' }).then((result) => {
      this.setState({ agreements: { ...this.state.agreements, privacyNoticeAcceptedDate: result.createdAt} });
      this.onClose();
    });
  }



  render() {
    const legalComplianceAgreementView =
      <Fieldset
        legend='Legal & Compliance'
        description='A copy of our standart terms and privacy policies, as well as amendments for your compliance needs are available below.'>
        <div className={styles.settingsBox}>
          <Field
            className='oneliner'
            label={<Label
              className='oneliner'
              tooltipText="Updated on 24 May 2018"
              text='Privacy Policy'
            />}
            input={
              this.state.agreements.privacyPoliciesAcceptedDate
                ?
                  <span className={styles.text14}>Accepted on {moment(this.state.agreements.privacyPoliciesAcceptedDate).format('DD MMM YYYY HH:mm:ss')} <strong>{this.state.acceptedBy}</strong></span>
                :
                  <a
                    className={[stylesButton.tableButton, stylesButton.green].join(' ')}
                    href='javascript:;'
                    onClick={() => this.setState({ showPrivacyPolicyModal: true })}>
                    Review and Accept
                  </a>
            }
          />

          <div className={styles.hr}></div>

          <Field
            className='oneliner'
            label={<Label
              className='oneliner'
              tooltipText="Updated on 24 May 2018"
              text='Terms of Service'
            />}
            input={
              this.state.agreements.termsOfServiceAcceptedDate
                ?
                  <span className={styles.text14}>Accepted on {moment(this.state.agreements.termsOfServiceAcceptedDate).format('DD MMM YYYY HH:mm:ss')} <strong>{this.state.acceptedBy}</strong></span>
                :
                  <a
                    className={[stylesButton.tableButton, stylesButton.green].join(' ')}
                    href='javascript:;'
                    onClick={() => this.setState({ showTermsOfServiceModal: true })}>
                    Review and Accept
                  </a>
            }
          />

          <div className={styles.hr}></div>

          <Field
            className='oneliner'
            label={<Label
              className='oneliner'
              text='Privacy Notice'
            />}
            input={
              this.state.agreements.privacyNoticeAcceptedDate
                ?
                  <span className={styles.text14}>Accepted on {moment(this.state.agreements.privacyNoticeAcceptedDate).format('DD MMM YYYY HH:mm:ss')} <strong>{this.state.acceptedBy}</strong></span>
                :
                  <a
                    className={[stylesButton.tableButton, stylesButton.green].join(' ')}
                    href='javascript:;'
                    onClick={() => this.setState({ privacyNoticeModal: true })}>
                    Review and Accept
                  </a>
            }
          />

          <div className={styles.hr}></div>

          <div className={[styles.onelinerWithLink, styles.text].join(' ')}>
            <a href='https://www.sashido.io/en/policies/dashboard#security-policy' target="_blank" rel='noreferrer noopener'>SashiDo Security Overview</a>
          </div>

        </div>
      </Fieldset>


    const representativeFullName = `${this.state.euRepresentative.first_name || ''} ${this.state.euRepresentative.last_name || ''}`

    const representativeAgreementView =
      <Fieldset
        legend='Your EU Representative'
        description='Person designated, where applicable, to represent customers not established in the EU with regard to their obligations under the General Data Protection Regulation (GDPR).'
        >
        <div className={styles.settingsBox}>
          {
            Object.keys(this.state.euRepresentative).length > 0 &&
              <div className={[billingStyles.box, billingStyles.table, billingStyles.billingInfo].join(' ')} style={{ marginBottom: 0 }}>
                <div className={billingStyles.tableRow}>
                  <div className={billingStyles.col1}>Representative Info</div>
                  {
                    this.state.euRepresentative.date &&
                      <div className={billingStyles.col2}>Last updated on {moment(this.state.euRepresentative.date).format('DD MMM YYYY HH:mm:ss')}</div>
                  }
                </div>

                <div className={[billingStyles.box, billingStyles.pa].join(' ')}>
                  <div className={[billingStyles.columns].join(' ')}>
                    <div className={billingStyles.left}>
                      <div className={billingStyles.row}>
                        <label>Full Name :</label>
                        <span>{representativeFullName}</span>
                      </div>
                      <div className={billingStyles.row}>
                        <label>Address :</label>
                        <span>{this.state.euRepresentative.address || ''}</span>
                      </div>
                    </div>

                    <div className={billingStyles.right}>
                      <div className={billingStyles.row}>
                        <label>E-mail :</label>
                        <span>{this.state.euRepresentative.email || ''}</span>
                      </div>
                      <div className={billingStyles.row}>
                        <label>Phone :</label>
                        <span>{this.state.euRepresentative.phone || ''}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          }

          {
            Object.keys(this.state.euRepresentative).length > 0
              ? <div className={styles.hr} style={{ marginTop: 0 }}></div>
              : <br />
          }

          <div className={billingStyles.box} style={{ paddingTop: 10 }}>
            <Button
              color='blue'
              value='Update Representative'
              block={true}
              onClick={() => history.push('/account/legal/EURepresentative/update')}
              />
          </div>

        </div>
      </Fieldset>


    const dpoFullName = `${this.state.dpo.first_name || ''} ${this.state.dpo.last_name || ''}`

    const dpoView =
      <Fieldset
        legend='Your Data Protection Officer (DPO)'
        description='Person designated, where applicable, to facilitate compliance with the provisions of the GDPR, which defines the criteria and the conditions under which a data protection officer shall be designated.'
        >
        <div className={styles.settingsBox}>
          {
            Object.keys(this.state.dpo).length > 0 &&
              <div className={[billingStyles.box, billingStyles.table, billingStyles.billingInfo].join(' ')} style={{ marginBottom: 0 }}>
                <div className={billingStyles.tableRow}>
                  <div className={billingStyles.col1}>Data Protection Officer Info</div>
                  {
                    this.state.dpo.date &&
                      <div className={billingStyles.col2}>Last updated on {moment(this.state.dpo.date).format('DD MMM YYYY HH:mm:ss')}</div>
                  }
                </div>

                <div className={[billingStyles.box, billingStyles.pa].join(' ')}>
                  <div className={[billingStyles.columns].join(' ')}>
                    <div className={billingStyles.left}>
                      <div className={billingStyles.row}>
                        <label>Full Name :</label>
                        <span>{dpoFullName}</span>
                      </div>
                      <div className={billingStyles.row}>
                        <label>Address :</label>
                        <span>{this.state.dpo.address || ''}</span>
                      </div>
                    </div>

                    <div className={billingStyles.right}>
                      <div className={billingStyles.row}>
                        <label>E-mail :</label>
                        <span>{this.state.dpo.email || ''}</span>
                      </div>
                      <div className={billingStyles.row}>
                        <label>Phone :</label>
                        <span>{this.state.dpo.phone || ''}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          }

          {
            Object.keys(this.state.dpo).length > 0
              ? <div className={styles.hr} style={{ marginTop: 0 }}></div>
              : <br />
          }

          <div className={billingStyles.box} style={{ paddingTop: 10 }}>
            <Button
              color='blue'
              value='Update Data Protection Officer'
              block={true}
              onClick={() => history.push('/account/legal/DPO/update')}
              />
          </div>
        </div>
      </Fieldset>

    const filesView =
      <Fieldset
        legend='Documents & Contracts'
        >
        <div className={styles.settingsBox}>
          <div className={[billingStyles.box, billingStyles.table, billingStyles.paymentHistory].join(' ')}>
            <div>
              <div className={billingStyles.tableRow}>
                <div className={billingStyles.col1}>Name</div>
                <div className={billingStyles.col5}>Preview</div>
              </div>

              <div className={billingStyles.tableRow}>
                <div className={billingStyles.col1}>Declaration for Non-Disclosure of Personal data and Information</div>
                <div className={billingStyles.col5}>
                  <a href="http://public-docs.cloudstrap.io/gdpr/Declaration_GDPR_SashiDo_signed.pdf" target="_blank" rel='noreferrer noopener'>
                    <Icon name='icon-download' width={16} height={16} colored={true} fill='#0092ff' onClick={() => {}} />
                  </a>
                </div>
              </div>

              <div className={billingStyles.tableRow}>
                <div className={billingStyles.col1}>Data Processing Agreement (DPA) Template</div>
                <div className={billingStyles.col5}>
                  <a href="http://public-docs.cloudstrap.io/gdpr/NDA_DPA_GDPR_Sashido_Template.pdf" target="_blank" rel='noreferrer noopener'>
                    <Icon name='icon-download' width={16} height={16} colored={true} fill='#0092ff' onClick={() => {}} />
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </Fieldset>

    const privacyPolicyModal =
      this.state.showPrivacyPolicyModal &&
        <Modal
          width={740}
          title='Privacy Policy'
          subtitle={['You will accept this agreement as ', <span key='subtitle'>{this.props.currentUser.email}</span>]}
          confirmText='I Accept'
          cancelText={'Go Back'}
          onCancel={() => this.onClose()}
          onConfirm={() => this.agreePrivacyPolicy()}
        >
          <div>
            <iframe className={styles.Policies} width='100%' height="100%" src={`https://www.sashido.io/en/policies/dashboard#privacy-policy`} />
            <div className={styles.modalCustomInfo}>
              <p>You represent and warrant that:</p>

              <ol>
                <li>You have full legal authority to agree to these terms presented above.</li>
                <li>You have read and understand these terms.</li>
                <li>You agree to these terms.</li>
              </ol>

              <p>If you do not have the authority, or do not agree to these terms, do not click the "I Accept" button below.</p>
            </div>
          </div>
        </Modal>;

    const tosModal =
      this.state.showTermsOfServiceModal &&
        <Modal
          width={740}
          title='Terms of Service'
          subtitle={['You will accept this agreement as ', <span key='subtitle'>{this.props.currentUser.email}</span>]}
          confirmText='I Accept'
          cancelText={'Go Back'}
          onCancel={() => this.onClose()}
          onConfirm={() => this.agreeTermsOfService()}
        >
          <div>
            <iframe className={styles.Policies} width='100%' height="100%" src={`https://www.sashido.io/en/policies/dashboard`} />
            <div className={styles.modalCustomInfo}>
              <p>You represent and warrant that:</p>

              <ol>
                <li>You have full legal authority to agree to these terms presented above.</li>
                <li>You have read and understand these terms.</li>
                <li>You agree to these terms.</li>
              </ol>

              <p>If you do not have the authority, or do not agree to these terms, do not click the "I Accept" button below.</p>
            </div>
          </div>
        </Modal>;

    const privacyNoticeModal =
      this.state.privacyNoticeModal &&
        <Modal
          width={740}
          title='Privacy Notice'
          subtitle={['You will accept this agreement as ', <span key='subtitle'>{this.props.currentUser.email}</span>]}
          confirmText='I Accept'
          cancelText={'Go Back'}
          onCancel={() => this.onClose()}
          onConfirm={() => this.agreePrivacyNotice()}
        >
          <div>
            <iframe className={styles.Policies} width='100%' height="100%" src={`https://www.sashido.io/en/policies/dashboard#gdpr-privacy-notice`} />
            <div className={styles.modalCustomInfo}>
              <p>You represent and warrant that:</p>

              <ol>
                <li>You have full legal authority to agree to these terms presented above.</li>
                <li>You have read and understand these terms.</li>
                <li>You agree to these terms.</li>
              </ol>

              <p>If you do not have the authority, or do not agree to these terms, do not click the "I Accept" button below.</p>
            </div>
          </div>
        </Modal>;

    const classes = [styles.settings_page, styles.default];

    return (
      <div className={classes.join(' ')}>
        <Toolbar section={this.props.section} subsection={this.props.subsection} />
        <PreLoader loading={this.state.loading}>
          <div className={styles.holder}>
            {
              this.showInfoBox &&
                <div className={[styles.noHolder].join(' ')}>
                  <div className={[styles.warningInfo].join(' ')}>
                    <p><strong>Thank you for being a loyal SashiDo customer.</strong></p>

                    <p>At SashiDo and CloudStrap as your hosting partner, we're committed to protecting your privacy.<br />That's something that will never change.</p>
                    <p>With regard to the application of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (GDPR), CloudStrap AD is applying an updated personal data protection policy regarding your personal data which you have provided us as our client.</p>
                    <p>Please review and accept the updated policies.</p>
                  </div>
                </div>
            }

            {legalComplianceAgreementView}
            {filesView}
            {representativeAgreementView}
            {dpoView}
            {privacyPolicyModal}
            {tosModal}
            {privacyNoticeModal}
          </div>
        </PreLoader>
      </div>
    );
  }
}
